import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const IconContainer = styled.div`
  &:not(:last-child) {
    margin-inline-end: 24px;

    ${theme.breakpoints.up("tablet")} {
      margin-inline-end: 32px;
    }
  }
`;
